export default __webpack_public_path__ + "fd0085ad1454f02478dc65539e3538f9.jpg";